import { useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { registerChatIntegrationDataHook } from "../../hooks/integrationDataHooks";
import type { KnowledgeDocumentListResponse } from "../../types";
import { knowledgeQueryKeys } from "../query-keys";

import type { ModuleDataValue } from "@/features/integrations/shared/renderer/hooks/types";
import { instance } from "@/lib/axios/instance";

registerChatIntegrationDataHook("captain", (_params) => {
  return useQuery<Record<string, ModuleDataValue>, AxiosError>({
    queryKey: knowledgeQueryKeys.metrics(),
    queryFn: async () => {
      const { data } =
        await instance.get<KnowledgeDocumentListResponse>(
          "/api/v2/captain/knowledge",
        );
      return {
        documentCount: data.total,
        indexedCount: data.documents.filter((d) => d.syncStatus === "synced")
          .length,
        pendingCount: data.documents.filter((d) => d.syncStatus !== "synced")
          .length,
      };
    },
  });
});
